import React, { useContext, useEffect, useState, useRef } from "react";
import Context from "../../../context/context";
import { NavLink as Link, useLocation } from "react-router-dom";
const Menu = () => {
  const { account, onConnect, providers, onDisconnect} = useContext(Context);
  const [isFixed, setIsFixed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
      const handleScroll = () => {
          setIsFixed(window.scrollY > 0); // becomes fixed when scroll > 0
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };
  return (
    <>
    <header  className={` ${isFixed ? "fixed" : ""}`}>
      <div className="PTGCSEC  leftrightSecSpace">
        <nav className="navbar navbar-expand-lg navbar-dark">
            <div className={`mobileMenu ${menuOpen ? "show1" : "" }`}>
              <div className="mobileMenuIN">
                <ul className="navbar-nav my-2 my-lg-0 navbar-nav-scroll w-auto" >
                  <li className="nav-item">
                    <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-staking">Staking</Link>
                  </li>
                  <li className="nav-item">
                    <Link  onClick={handleCloseMenu} className="nav-link" to="/ptgc-dao">Dao</Link>
                  </li>
                  <li className="nav-item">
                    <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-statistics">Statistics</Link>
                  </li>
                  <li className="nav-item">
                    <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-onboarding">Onboarding</Link>
                  </li>

                  <li className="nav-item">
                    <Link onClick={handleCloseMenu} className="nav-link" to="https://the-grays-currency.printify.me/" target='_blank'>Grays Gear</Link>
                  </li>
                </ul>
                <div className="d-flex  align-items-center w-100">
                  <div className="d-flex flex-wrap gap-2 w-100 menuBo">
                    <div className="brnaChange">
                      <Link to="/ufo"><img src="./images/ptgc/ufologo_circle.svg" className="img-fluid"/></Link>
                    </div>
                    <div className="connectWallet">
                      {
                        account ?
                          <button className="mybtn  border-0 " title={account} onClick={onDisconnect}>
                            <div className="btnIN borderbtn">
                              <span>{account.substring(0, 6)}....{account.substring(36, 42)} <i className="fa-solid fa-arrow-right-from-bracket"></i></span> 
                            </div>
                          </button>
                          :
                          <button className="mybtn  border-0  d-flex align-items-center" onClick={onConnect}>
                            <div className="btnIN borderbtn"> 
                              <span>Connect Wallet</span>
                            </div>
                          </button> 
                      }
                    </div>
                  </div>
                </div>
                <div className="menuBottom">
                  </div>
              </div>
            </div>
            <div className="row align-items-center w-100 m-md-0">
              <div className="col-lg-4 col-xl-3   p-md-0">
                <div className='menuTop'>
                <Link className="navbar-brand" to="/">
                  <img className="logo desktop" src="./images/ptgc/logo.svg" alt="" />
                </Link>
                <button  className={`navbar-toggler collapsed ${menuOpen ? "show1" : ""}`} onClick={handleToggleMenu} type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample07XL" aria-controls="navbarsExample07XL" aria-expanded="false" aria-label="Toggle navigation">
                  <img src="./images/menuicon.svg" className="img-fluid fa-bars"/>
                  <img src="./images/X.svg" className="img-fluid fa-close"/>
                </button>
                </div>
              </div>
              <div className="col-lg-4 col-xl-6 mobHide  p-md-0">
                <div className="d-flex justify-content-center">
                  <ul className="navbar-nav my-2 my-lg-0 navbar-nav-scroll w-auto" >
                    <li className="nav-item">
                      <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-staking">Staking</Link>
                    </li>
                    <li className="nav-item">
                      <Link  onClick={handleCloseMenu} className="nav-link"  to="/ptgc-dao">Dao</Link>
                    </li>
                    <li className="nav-item">
                      <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-statistics">Statistics</Link>
                    </li>
                    <li className="nav-item">
                       <Link onClick={handleCloseMenu} className="nav-link" to="/ptgc-onboarding">Onboarding</Link>
                    </li>
                    <li className="nav-item">
                      <Link onClick={handleCloseMenu} className="nav-link" to="https://the-grays-currency.printify.me/" target='_blank'>Grays Gear</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-xl-3 mobHide  p-md-0">
                <div className="d-flex  align-items-center w-100">
                  <div className="d-flex flex-wrap gap-4 w-100 justify-content-end">
                    <div className="brnaChange">
                      <Link to="/ufo"><img src="./images/ptgc/ufologo_circle.svg" className="img-fluid"/></Link>
                    </div>
                    <div className="connectWallet">
                      {
                      account ?
                        <button className="mybtn  border-0 " title={account} onClick={onDisconnect}>
                          <div className="btnIN borderbtn">
                            <span>{account.substring(0, 6)}....{account.substring(36, 42)} <i className="fa-solid fa-arrow-right-from-bracket"></i></span> 
                          </div>
                        </button>
                          :
                        <button className="mybtn  border-0 d-flex align-items-center" onClick={onConnect}>
                          <div className="btnIN borderbtn"><span>Connect Wallet</span></div>
                        </button> 
                      }
                    </div>
                  </div>
              </div>
            </div>
          </div>
      </nav>
    </div>
  </header>
    </>
  );
};
export default Menu;